import React, { Fragment } from "react";
import { useEffect } from "react";

import { useConfig } from "../../core/config";
import { makeAdsConversionClient } from "../../lib/analytics/ads_conversion";
import { useAnalytics } from "../../lib/analytics/analytics";
import { makePixelClient } from "../../lib/analytics/pixel";
import { makeGA4Client } from "../../lib/analytics/ga4";

export function useFoundrSpaceAnalytics() {
  const config = useConfig();
  const analytics = useAnalytics();

  useEffect(() => {
    const variables = envVariables[config.environment];

    if (variables.fbPixelId) {
      const pixelClient = makePixelClient(variables.fbPixelId);

      analytics.addClient(pixelClient);
    }

    if (variables.adsId) {
      const adsConversionClient = makeAdsConversionClient(
        variables.adsId,
        variables.adsSlot
      );

      analytics.addClient(adsConversionClient);
    }

    if (variables.ga4TrackingId) {
      const ga4Client = makeGA4Client({
        trackingId: variables.ga4TrackingId,
        gaOptions: {
          name: "foundrspace",
        },
      });

      analytics.addClient(ga4Client);
    }
  }, [config.environment, analytics]);
}

const envVariables = {
  development: {
    ga4TrackingId: "",
    fbPixelId: "729168348166124",
    adsId: "",
    adsSlot: "",
  },
  staging: {
    ga4TrackingId: "G-F60JC9HLP6",
    fbPixelId: "452265623448985",
    adsId: "",
    adsSlot: "",
  },
  production: {
    ga4TrackingId: "G-83XYD7W08L",
    fbPixelId: "514093553402136",
    adsId: "AW-712319115",
    adsSlot: "OKcLCOXn164DEIvB1NMC",
  },
};

export default function FoundrSpaceAnalytics(): JSX.Element {
  useFoundrSpaceAnalytics();

  return <Fragment></Fragment>;
}
